<template>
  <v-card>
    <v-card-title style="align-items: center"
      >Change Time Schedule
      <v-spacer />
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div class="py-3">
        <date-picker-wrapper-input-menu label="Date" v-model="localSelectedDate" />
      </div>
      <div class="py-3">
        <v-select
          label="Time"
          outlined
          v-model="start"
          :items="item"
          item-text="text"
          item-value="value"
        />
      </div>
      <div class="d-flex justify-end">
        <v-btn :disabled="!start" @click="save">Save</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import { updateTimeTable } from '@/api/timetable';
import api from '@/api';
import DatePickerWrapperInputMenu from '@/components/DatePickerWrapperInputMenu';

export default {
  name: 'RearrangeTimetableDialog',
  components: { DatePickerWrapperInputMenu },
  props: {
    id: String,
    timeStart: { h: Number, m: Number },
    timeEnd: { h: Number, m: Number },
    selectedDate: {},
    duration: Number,
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
    localSelectedDate() {
      this.timeInit();
    },
  },
  data() {
    return {
      item: [],
      localSelectedDate: null,
      start: null,
    };
  },
  methods: {
    moment,
    async save() {
      try {
        const out = await updateTimeTable(api, this.id, {
          time: { start: moment(this.start), end: moment(this.start + this.duration) },
        });
        this.$emit('update', out);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.close();
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    close() {
      this.$emit('close');
    },
    timeInit() {
      this.item = [];
      const start = +moment(this.localSelectedDate).startOf('day').add(this.timeStart).toDate();
      const end = +moment(this.localSelectedDate).startOf('day').add(this.timeEnd).toDate();
      for (let i = start; i < end; i = i + 900000) {
        this.item.push({ value: i, text: moment(i).format('hh:mm') });
      }
    },
    async reload() {
      this.localSelectedDate = moment(this.selectedDate).format('YYYY-MM-DD');
      this.timeInit();
    },
  },
};
</script>

<style scoped></style>
